// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coin-container {
  touch-action: none;
  -ms-touch-action: none;
  visibility: visible !important;
  transition: all 0.2s ease-out;
}
.coin-container.disabled {
  opacity: 0.3;
}

.coin-label {
  max-width: 75px;
}

.drop-zone-sticky {
  top: -12px;
}

.no-margin {
  margin: 0;
}

.select-wrapper {
  width: 70px;
  margin-right: 20px;
}

.select-preset {
  width: 110px;
}

.asset-select-inputs label {
  margin-right: 10px;
}
.asset-select-inputs select {
  margin-right: 25px;
}

.info-panel {
  margin: 0 20px 12px;
}

.info-panel-gia {
  margin: 0 0 20px 0;
}

.wrappers-allocation h4 {
  text-align: center;
  height: 35px;
  margin: 0px auto;
}

/* TODO(mdc-migration): The following rule targets internal classes of slide-toggle that may no longer apply for the MDC version.*/
mat-slide-toggle {
  margin-right: 10px;
}

.isa-panel h4 {
  text-align: center;
  height: 20px;
}
.isa-panel mat-select {
  width: 100%;
}
.isa-panel .isa-allocation {
  width: 100%;
}

#dropzone_liabilities_2 .coin,
#dropzone_liabilities_1 .coin,
#dropzone_assets_2 .coin,
#dropzone_assets_1 .coin {
  display: none !important;
}

.disabled .coin {
  cursor: default;
}

.btn-options mat-icon {
  transition: all 0.2s ease-out;
  transform: rotate(-90deg);
}

.btn-options-open mat-icon {
  margin-top: -5px;
  transform: rotate(0deg);
}`, "",{"version":3,"sources":["webpack://./src/app/components/onboarding/balance/balance.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,sBAAA;EACA,8BAAA;EACA,6BAAA;AADF;AAEE;EACE,YAAA;AAAJ;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAIE;EACE,kBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAOE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAJJ;;AAQA,kIAAA;AACA;EACE,kBAAA;AALF;;AASE;EACE,kBAAA;EACA,YAAA;AANJ;AASE;EACE,WAAA;AAPJ;AAUE;EACE,WAAA;AARJ;;AAYA;;;;EAIE,wBAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAaE;EACE,6BAAA;EACA,yBAAA;AAVJ;;AAgBE;EACE,gBAAA;EACA,uBAAA;AAbJ","sourcesContent":["\n\n.coin-container {\n  touch-action: none;\n  -ms-touch-action: none;\n  visibility: visible !important;\n  transition: all 0.2s ease-out;\n  &.disabled {\n    opacity: 0.3;\n  }\n}\n.coin-label {\n  max-width: 75px;\n}\n\n.drop-zone-sticky{\n  top: -12px;\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.select-wrapper {\n  width: 70px;\n  margin-right: 20px;\n}\n\n.select-preset {\n  width: 110px;\n}\n\n.asset-select-inputs {\n  & label {\n    margin-right: 10px;\n  }\n\n  & select {\n    margin-right: 25px;\n  }\n}\n\n.info-panel {\n  margin: 0 20px 12px;\n}\n\n.info-panel-gia {\n  margin: 0 0 20px 0;\n}\n\n.wrappers-allocation {\n  & h4 {\n    text-align: center;\n    height: 35px;\n    margin: 0px auto;\n  }\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of slide-toggle that may no longer apply for the MDC version.*/\nmat-slide-toggle {\n  margin-right: 10px;\n}\n\n.isa-panel {\n  & h4 {\n    text-align: center;\n    height: 20px;\n  }\n\n  & mat-select {\n    width: 100%;\n  }\n\n  & .isa-allocation {\n    width: 100%;\n  }\n}\n\n#dropzone_liabilities_2 .coin,\n#dropzone_liabilities_1 .coin,\n#dropzone_assets_2 .coin,\n#dropzone_assets_1 .coin {\n  display: none !important;\n}\n\n.disabled .coin {\n  cursor: default;\n}\n\n.btn-options {\n  mat-icon {\n    transition: all 0.2s ease-out;\n    transform: rotate(-90deg);\n    // margin-left: 10px;\n  }\n}\n\n.btn-options-open {\n  mat-icon {\n    margin-top: -5px;\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
